import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  ToolbarService,
  LinkService,
  ImageService,
  HtmlEditorService,
} from "@syncfusion/ej2-angular-richtexteditor";
import { TranslateService } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ToastrService } from "ngx-toastr";
import { CrudService } from "src/app/Services/crud.service";
import { LoadingService } from "src/app/Services/loading.service";

@Component({
  selector: "app-add-edit-translation",
  templateUrl: "./add-edit-translation.component.html",
  providers: [ToolbarService, LinkService, ImageService, HtmlEditorService],
  standalone: false,
})
export class AddEditTranslationComponent implements OnInit {
  @Input() data: string = "";
  @Input() placeholder: string = "";
  @Input()
  tooltipData;
  @Input() languageId;
  @Output() save = new EventEmitter<string>();

  @Input() languageList = [];
  isEditing: boolean = false;
  loadingSub;
  isLoading: boolean = false;
  public toolbarSettings: object = {
    items: ["Bold", "Italic", "Underline", "Formats", "Undo", "Redo"],
  };

  constructor(
    private translateService: TranslateService,
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private crudService: CrudService,
    private loadingService: LoadingService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    if (!this.data) {
      this.isEditing = true;
      this.data = "";
    }
    this.loadingSub = this.loadingService.loading$.subscribe((val) => {
      this.isLoading = val;
    });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  toggleEdit() {
    this.isEditing = !this.isEditing;
  }

  saveEdit() {
    if (!this.data) {
      this.toastr.error("Text required.", "Invalid Operation");
      return;
    }

    if (
      this.tooltipData.supportedLanguage["id"] != null &&
      this.tooltipData.supportedLanguage["id"] != undefined &&
      this.tooltipData.supportedLanguage["id"].trim()
    ) {
      var payload = {
        //  ...this.tooltipData.primaryLanguage,
        hint: this.data,
        languageId: this.languageId,
      };
      this.crudService.update(
        payload,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.toastr.success(
              "Tooltip has been created successfully.",
              "Success"
            );
            this.save.emit();
            this.isEditing = false;
          }
        },
        "currentTooltipDetails/" + this.tooltipData.supportedLanguage["id"]
      );
    } else {
      var payloadForAdd = {
        ...this.tooltipData.primaryLanguage,
        hint: this.data,
        languageId: this.languageId,
        id: null,
      };
      this.crudService.post(
        payloadForAdd,
        (response) => {
          if (
            response.error &&
            response.error.error &&
            response.error.error.message
          ) {
            this.toastr.error(
              response.error.error.message,
              "Invalid Operation"
            );
          } else {
            this.toastr.success(
              "Tooltip has been created successfully.",
              "Success"
            );
            this.save.emit();
            this.isEditing = false;
          }
        },
        "currentTooltipDetails"
      );
    }
  }
}
